
function convertToUserTimezone(time, start_date, estTimezoneOffset, userTimezoneOffset) {
    const [hours, minutes, period] = time.match(/(\d+):(\d+) (am|pm)/).slice(1);
    let date = new Date();
    date.setDate(date.getDate() + ((7 + ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].indexOf(start_date) - date.getDay()) % 7));
    date.setHours((period === 'pm' ? parseInt(hours) % 12 + 12 : parseInt(hours) % 12));
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);

    // Convert from EST (UTC-5) to user time zone
    const estOffset = estTimezoneOffset * 60; // EST is UTC-5
    const userOffsetMinutes = userTimezoneOffset * 60;
    const totalOffset = estOffset - userOffsetMinutes;
    date.setMinutes(date.getMinutes() - totalOffset);

    return date;
}

function getTimeZoneAbbreviation() {
    const date = new Date();
    const fullTimeZone = date.toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];
    return fullTimeZone;
  }

function formatTime(date) {
    const options = { hour: 'numeric', minute: 'numeric', hour12: true };
    return date.toLocaleTimeString([], options);
}

function processDaysOfOperation() {
    if (!document.querySelectorAll('.ouw-working-hours').length) return
    [...document.querySelectorAll('.ouw-working-hours')].forEach((container) => {
        const daysOfOperation = JSON.parse(container.dataset.days);
        const show_tz_name = container.dataset.timezone;

        const estTimezoneOffset = container.dataset.offset;
        const userTimezoneOffset = -new Date().getTimezoneOffset() / 60; // Get user's timezone offset in hours
        let result = {};

        daysOfOperation.forEach(current => {
            if (!current.start_hours || !current.end_hours || !current.start_day) return;
            let start_date = convertToUserTimezone(current['start_hours'], current['start_day'], estTimezoneOffset, userTimezoneOffset);
            let end_date = convertToUserTimezone(current['end_hours'], current['start_day'], estTimezoneOffset, userTimezoneOffset);
            let start_hours = formatTime(start_date);
            let end_hours = formatTime(end_date);

            let start_day = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(start_date);
            let end_day = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(end_date);

            if (!result[start_day]) {
                result[start_day] = [];
            }
            if (end_date.getDate() !== start_date.getDate()) {
                // Split into two ranges
                result[start_day].push(`${start_hours} - 11:59 PM`);
                if (!result[end_day]) {
                    result[end_day] = [];
                }
                result[end_day].push(`12:00 AM - ${end_hours}`);
            } else {
                result[start_day].push(`${start_hours} - ${end_hours}`);
            }
        });

        // Display the result

        let lastResult = {};
        let optimizeDays = [];
        let deleteDay = '';
        for (let day in result) {
            if (result[day].join(', ') === lastResult.time) {
                if (deleteDay) {
                    delete optimizeDays[deleteDay];
                    deleteDay = '';
                }
                optimizeDays[lastResult.day + '-' + day] = result[day];
                deleteDay = lastResult.day + '-' + day;
                continue;
            }
            else {
                optimizeDays[day] = result[day];
                deleteDay = day;
            }

            lastResult = {
                day,
                'time': result[day].join(', ')
            };
        }
        container.innerHTML = '';
        for (let day in optimizeDays) {
            container.innerHTML += `<div class="working-day"><strong>${day}</strong> ${optimizeDays[day].join(', ')} ${show_tz_name ? getTimeZoneAbbreviation() : ''}</div>`;
        }
    })
}

export { convertToUserTimezone, formatTime, processDaysOfOperation };